import clsx from 'clsx';

import { LogoIcon } from './LogoIcon';
import { useAppContext } from '../../shared';

export const Logo = () => {
  const { meta } = useAppContext();

  return (
    <div
      className={clsx(
        'pb-lg grow w-full text-center flex items-center gap-x-lg',
        'sticky top-[2.4rem] bg-bg'
      )}
    >
      <LogoIcon />
      <span className="font-bold text-section">
        {meta.tenant.name || ' - '}
      </span>
    </div>
  );
};
